import React from "react";
import { ToastContextType } from "./ToastService.types";

export const ToastContext = React.createContext<ToastContextType | undefined>(
  undefined
);
